import { gatsbyMediaArray } from './gatsbyMedia'
import { gatsbyBio } from './gatsbyBios'
import { hollyProfileReviewHinge, luigiProfileReviewBumble, frodoProfileReviewTinder } from './gatsbyProfileReviews'

export const gatsbyDatingProfileHinge = {
  _id: 'gatsbyDatingProfileHingeId',
  userId: 'gatsbyUserId',
  email: 'gatsby@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: gatsbyMediaArray[0]._id,
      mediaItemURL: gatsbyMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[0].type,
      caption: gatsbyMediaArray[0].captions[0],
      subcaption: gatsbyMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[1]._id,
      mediaItemURL: gatsbyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[1].type,
      caption: gatsbyMediaArray[1].captions[0],
      subcaption: gatsbyMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[5]._id,
      mediaItemURL: gatsbyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[5].type,
      caption: gatsbyMediaArray[5].captions[2],
      subcaption: gatsbyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[11]._id,
      mediaItemURL: gatsbyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[11].type,
      caption: gatsbyMediaArray[11].captions[0],
      subcaption: gatsbyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[8]._id,
      mediaItemURL: gatsbyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[8].type,
      caption: gatsbyMediaArray[8].captions[0],
      subcaption: gatsbyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[10]._id,
      mediaItemURL: gatsbyMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[10].type,
      caption: gatsbyMediaArray[10].captions[2],
      subcaption: gatsbyMediaArray[10].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: gatsbyBio._id,
    vitalInfo: { ...gatsbyBio.vitalInfo },
    prompts: [
      { ...gatsbyBio.prompts[0] },
      { ...gatsbyBio.prompts[1] },
      { ...gatsbyBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...hollyProfileReviewHinge }
  ],
  mediaItems: [ ...gatsbyMediaArray ],
  bioItems: { ...gatsbyBio },
}

export const gatsbyDatingProfileBumble = {
  _id: 'gatsbyDatingProfileBumbleId',
  userId: 'gatsbyUserId',
  email: 'gatsby@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: gatsbyMediaArray[0]._id,
      mediaItemURL: gatsbyMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[0].type,
      caption: gatsbyMediaArray[0].captions[0],
      subcaption: gatsbyMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[1]._id,
      mediaItemURL: gatsbyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[1].type,
      caption: gatsbyMediaArray[1].captions[0],
      subcaption: gatsbyMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[5]._id,
      mediaItemURL: gatsbyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[5].type,
      caption: gatsbyMediaArray[5].captions[2],
      subcaption: gatsbyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[11]._id,
      mediaItemURL: gatsbyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[11].type,
      caption: gatsbyMediaArray[11].captions[0],
      subcaption: gatsbyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[8]._id,
      mediaItemURL: gatsbyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[8].type,
      caption: gatsbyMediaArray[8].captions[0],
      subcaption: gatsbyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[10]._id,
      mediaItemURL: gatsbyMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[10].type,
      caption: gatsbyMediaArray[10].captions[2],
      subcaption: gatsbyMediaArray[10].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: gatsbyBio._id,
    vitalInfo: { ...gatsbyBio.vitalInfo },
    prompts: [
      { ...gatsbyBio.prompts[0] },
      { ...gatsbyBio.prompts[1] },
      { ...gatsbyBio.prompts[2] }
    ],
    aboutMe: gatsbyBio.aboutMe[0],
    hobbies: [gatsbyBio.hobbies[0], gatsbyBio.hobbies[1], gatsbyBio.hobbies[2], gatsbyBio.hobbies[3], gatsbyBio.hobbies[4] ],
  },
  profileReviews: [
    { ...luigiProfileReviewBumble }
  ],
  mediaItems: [ ...gatsbyMediaArray ],
  bioItems: { ...gatsbyBio },
}

export const gatsbyDatingProfileTinder = {
  _id: 'gatsbyDatingProfileTinderId',
  userId: 'gatsbyUserId',
  email: 'gatsby@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: gatsbyMediaArray[0]._id,
      mediaItemURL: gatsbyMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[0].type,
      caption: gatsbyMediaArray[0].captions[0],
      subcaption: gatsbyMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[1]._id,
      mediaItemURL: gatsbyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[1].type,
      caption: gatsbyMediaArray[1].captions[0],
      subcaption: gatsbyMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[5]._id,
      mediaItemURL: gatsbyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[5].type,
      caption: gatsbyMediaArray[5].captions[2],
      subcaption: gatsbyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[11]._id,
      mediaItemURL: gatsbyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[11].type,
      caption: gatsbyMediaArray[11].captions[0],
      subcaption: gatsbyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[8]._id,
      mediaItemURL: gatsbyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[8].type,
      caption: gatsbyMediaArray[8].captions[0],
      subcaption: gatsbyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[10]._id,
      mediaItemURL: gatsbyMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[10].type,
      caption: gatsbyMediaArray[10].captions[2],
      subcaption: gatsbyMediaArray[10].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: gatsbyBio._id,
    vitalInfo: { ...gatsbyBio.vitalInfo },
    prompts: [
      { ...gatsbyBio.prompts[0] },
      { ...gatsbyBio.prompts[1] },
      { ...gatsbyBio.prompts[2] }
    ],
    aboutMe: gatsbyBio.aboutMe[0],
    hobbies: [gatsbyBio.hobbies[0], gatsbyBio.hobbies[1], gatsbyBio.hobbies[2], gatsbyBio.hobbies[3], gatsbyBio.hobbies[4] ],
  },
  profileReviews: [
    { ...frodoProfileReviewTinder }
  ],
  mediaItems: [ ...gatsbyMediaArray ],
  bioItems: { ...gatsbyBio },
}